<app-logic-transfer-form
  data-testid="logic-transfer-edit-form-wrapper"
  #formWrapper
  [config]="config"
  [editMode]="editMode"
  [initialData]="initialData()"
  [height]="'100%'"
></app-logic-transfer-form>

<!-- Toast Messages -->
<p-toast data-testid="logic-transfer-edit-toast"></p-toast>
